import { render, staticRenderFns } from "./CathayCustInfoModal.vue?vue&type=template&id=7a54062f&scoped=true"
import script from "./CathayCustInfoModal.vue?vue&type=script&lang=js"
export * from "./CathayCustInfoModal.vue?vue&type=script&lang=js"
import style0 from "./CathayCustInfoModal.vue?vue&type=style&index=0&id=7a54062f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a54062f",
  null
  
)

export default component.exports